import { forwardRef } from "react";
import { LucideIcon } from "lucide-react";
import { Button, ButtonProps } from "@/ui/components/ui/button";
import { cn } from "@/utils/module_api";

interface IconButtonProps extends Omit<ButtonProps, "children"> {
  icon: LucideIcon;
  label?: string;
  iconClassName?: string;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ icon: Icon, label, iconClassName, className, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        variant="ghost"
        size="icon"
        className={cn("h-10 w-10", className)}
        {...props}
      >
        <Icon className={cn("h-5 w-5", iconClassName)} />
        {label && <span className="sr-only">{label}</span>}
      </Button>
    );
  }
);

IconButton.displayName = "IconButton";
